module.exports = function getResource(label) {
    const resources = {
        removePhoto: 'Retirer la photo',
        addPhoto: 'Ajouter une photo',
        somethingWentWrongError: 'An error occurred during the submission process, please retry at a later time.'
    };
    return resources[label];
};
